<template>
  <el-dialog
      :visible.sync="visible"
      title="批量创建采购合同"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
  >
    <el-form
        :model="dataForm"
        :rules="dataRule"
        ref="dataForm"
        label-width="120px"
    >
      <div class="table-bar" style="justify-content: flex-start;margin-bottom: 0px">
        <div class="bar-item">
          <UploadButton url="/erp/purchase/import" @success="readFileSuccess"></UploadButton>
        </div>
        <FileLink file-type="front" file-url="/static/template/采购合同批量导入模板.xlsx" class="bar-item">下载模板
        </FileLink>
      </div>
      <ImportErrorCard :errorList="errorList"></ImportErrorCard>
      <SweetTable :data="dataForm.detailList" :is-page="false" :height="500"
                  :summaries-column="['amount','count']">
        <el-table-column label="订单编号" prop="orderCode" align="center">
        </el-table-column>
        <el-table-column label="原料名称" prop="product.name"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="颜色" prop="product.color"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="规格" prop="product.size"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="幅宽" prop="product.attr1"
                         align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="克重" prop="product.attr2"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="采购数量" prop="count"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="采购单价" prop="amount"
                         align="center" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            label="供应商"
            prop="companyName"
            header-align="center"
            align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column
            label="收货工厂"
            prop="receiverName"
            header-align="center"
            align="center" :show-overflow-tooltip="true" :formatter="$c.companyNameFormatter">
        </el-table-column>
        <el-table-column label="交期" width="120" prop="deadLine" align="center">
        </el-table-column>
      </SweetTable>
    </el-form>
    <template slot="footer">
      <el-button size="mini" @click="visible=false">{{ $t('cancel') }}</el-button>
      <el-button size="mini" type="primary" @click="dataFormSubmitHandle">保存</el-button>
    </template>
  </el-dialog>
</template>

<script>
/**
 * 供应商成品发货弹窗
 */
import UploadButton from '@/components/UploadButton.vue'
import debounce from 'lodash/debounce'
import { countValidator, moneyValidator } from '@/utils/validate'
import ProductRowCard from '@/components/ProductRowCard.vue'
import moment from 'moment'
import BigNumber from 'bignumber.js'
import ImportErrorCard from '@/components/ImportErrorCard.vue'
import FileLink from '@/components/FileLink.vue'

export default {
  name: 'CreateDialog',
  components: { FileLink, ProductRowCard, UploadButton, ImportErrorCard },
  data () {
    return {
      visible: false,
      dataForm: {},
      errorList: [],
    }
  },
  computed: {
    dataRule () {
      return {}
    }
  },
  methods: {
    readFileSuccess (result) {
      this.errorList = result.errorList
      if (!this.$c.isArrayEmpty(result.dataList)) {
        this.dataForm.detailList = result.dataList
      }
    },
    init (detailList) {
      this.errorList = []
      this.dataForm = {
        detailList: detailList,
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    // 表单提交
    dataFormSubmitHandle:
        debounce(
            function () {
              this.$refs['dataForm'].validate((valid) => {
                if (!valid) {
                  return false
                }
                let postForm = this.$clone(this.dataForm.detailList)
                this.loading = true
                this.$api2
                    .post('/erp/purchase/save', postForm)
                    .then(res => {
                      this.loading = false
                      this.$c.success('保存成功').then(() => {
                        this.visible = false
                        this.$emit('change')
                      })
                    })
                    .catch((e) => {
                      this.loading = false
                    })
              })
            },
            1000,
            { leading: true, trailing: false }
        )
  },
}
</script>

